import { createConfigurable } from '@peloton/config-singleton';

export const { config, updateConfig } = createConfigurable({
  libraryPageSize: 18,
});
